import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSCidadeService from '@/services/Cadastros/Gerais/cidade.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useCidadeList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSCidadeService = new SLSCidadeService();
  const refCidadeListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'cidadeid', label: 'Codigo', sortable: true },
    { key: 'cidade_nome', label: 'Nome', sortable: true },
    { key: 'cidade_zona_franca', label: 'Zona', sortable: true },
    { key: 'pais.pais_nome', label: 'Pais' },
    { key: 'uf.uf_nome', label: 'Uf' },
    { key: 'actions', label: 'Ações' },
  ];
  const perPage = ref(10);
  const totalCidade = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const searchIdPais = ref(null);
  const searchIdUf = ref(null);
  const sortBy = ref('cidadeid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refCidadeListTable.value ? refCidadeListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCidade.value,
    };
  });

  const refetchData = () => {
    refCidadeListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, searchIdPais, searchIdUf, statusFilter], () => {
    refetchData();
  });

  const fetchCidade = (ctx, callback) => {
    overlay.value = true;
    sLSCidadeService.index({
      q: searchQuery.value,
      id_pais: searchIdPais.value,
      id_uf: searchIdUf.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalCidade.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    await sLSCidadeService.store(body);
    refetchData();
  };
  const Updated = async (body) => {
    await sLSCidadeService.update(body.cidadeid, body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSCidadeService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchCidade,
    tableColumns,
    perPage,
    currentPage,
    totalCidade,
    dataMeta,
    perPageOptions,
    searchQuery,
    searchIdUf,
    searchIdPais,
    sortBy,
    isSortDirDesc,
    refCidadeListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
